export enum PrintQuality {
  EXCELLENT = 'excellent',
  GOOD = 'good',
  ACCEPTABLE = 'acceptable',
  POOR = 'poor'
}

type DPIInfo = {
  effectiveDPI: number
  quality: PrintQuality
  warning?: string
}

const MM_TO_INCH = 25.4

export const calculateEffectiveDPI = (
  imageWidthPx: number,
  imageHeightPx: number,
  frameWidthMM: number,
  frameHeightMM: number
): DPIInfo => {
  const frameWidthInch = frameWidthMM / MM_TO_INCH
  const frameHeightInch = frameHeightMM / MM_TO_INCH

  const widthDPI = imageWidthPx / frameWidthInch
  const heightDPI = imageHeightPx / frameHeightInch

  const effectiveDPI = Math.min(widthDPI, heightDPI)

  let quality: PrintQuality
  let warning: string | undefined

  if (effectiveDPI >= 400) {
    quality = PrintQuality.EXCELLENT
  } else if (effectiveDPI >= 300) {
    quality = PrintQuality.GOOD
  } else if (effectiveDPI >= 200) {
    quality = PrintQuality.ACCEPTABLE
    warning = 'Image quality may appear slightly pixelated in print'
  } else {
    quality = PrintQuality.POOR
    warning = 'Image quality too low for professional printing'
  }

  return {
    effectiveDPI: Math.round(effectiveDPI),
    quality,
    warning
  }
}

export const getQualityColor = (quality: PrintQuality): string => {
  switch (quality) {
    case PrintQuality.EXCELLENT:
      return '#10B981'
    case PrintQuality.GOOD:
      return '#84CC16'
    case PrintQuality.ACCEPTABLE:
      return '#F59E0B'
    case PrintQuality.POOR:
      return '#EF4444'
  }
}
